import i18n from "src/i18n/config";
import { z } from "zod";

export const validationSchema = z.object({
    name: z.string().min(3).max(64).regex(/^\w+$/, i18n.t("common:validation.custom.nameSpecialChars")),
    password: z
        .string()
        .min(3)
        .max(64)
        .regex(/^[ \w\d.,:+#@-]*$/, i18n.t("common:validation.custom.passwordSpecialChars")),
    title: z
        .string()
        .min(3)
        .max(64)
        .regex(/^[ \w\d.,:+#@-]*$/, i18n.t("common:validation.custom.titleSpecialChars")),
    description: z
        .string()
        .min(3)
        .max(64)
        .regex(/^[ \w\d.,:+#@-]*$/, i18n.t("common:validation.custom.descriptionSpecialChars")),
});
